import React from "react";
import PropagateLoader from "react-spinners/PropagateLoader";
let Loading = () => (
  <div
    className="Load"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "90vh",
    }}
  >
    <PropagateLoader color="black" />
  </div>
);

export default Loading;
